import React from "react";
import RightSectionEM from "../educationMamaComponents/RightSectionEM/RightSectionEM";
import Logo from "../../../src/public/images/logo.png";
import HeaderComponent from "./HeaderComponent";
import "./invoiceDesign.scss";
import moment from "moment";

const AggregateInvoiceDesign = ({ invoiceDetails }) => {
  console.log("Aggregate Invoice", invoiceDetails);

  const totalAmount = () => {
    const totalAmount = invoiceDetails.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.amount_payable;
    }, 0);
    return totalAmount;
  };

  const invoiceStatus = (status) => {
    if (status === 1 || status === 2) {
      return <button className="invoicePaid">Paid</button>;
    } else if (status === 3) {
      return <button className="invoiceCancelled">Cancelled</button>;
    } else if (status === 0) {
      return <button className="invoiceUnpaid">Unpaid</button>;
    }
  };
  return (
    <div className="FeedComponent FeedComponentForTeacher">
      <div style={{ padding: "2vh 0" }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="">
                <div className="row">
                  {/* <div className="col-md-12 p-3" style={{ background: "#004AAD" }}>
                    <div className="d-flex justify-content-between">
                      <img src={Logo} />
                      <h3 className="text-light my-auto">INVOICE</h3>
                    </div>
                  </div> */}
                  <div className="">
                    <div className="row smallLabelForMobile">
                      {invoiceDetails && (
                        <>
                          <div className="col-md-12 text-right mt-4">
                            <label>Invoice No : {invoiceDetails[0]["id"]}</label> <br />
                            <label>
                              Invoice Date : {moment(invoiceDetails[0].ts).format("Do MMMM YYYY")}
                            </label>{" "}
                            <br />
                          </div>
                          <div className="col-md-12 text-right">
                            <div className="d-flex justify-content-between">
                              <div style={{ color: "#004AAD" }}>
                                <h3>{invoiceDetails[0]?.candidate_nu_users?.user_name}</h3>
                              </div>

                              <div className="text-right">
                                <label>
                                  Due Date :{" "}
                                  {moment(invoiceDetails[0]?.due_date).format("Do MMMM YYYY")}
                                </label>{" "}
                                <br />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="col-md-12">
                        <table className="table">
                          <thead>
                            <tr className="tableForInvoice">
                              <th scope="col">COURSES</th>
                              {/* <th scope="col">PERIOD</th> */}
                              {/* <th className="text-center" scope="col">
                                LATE FEE
                              </th> */}
                              <th className="text-center" scope="col">
                                TOTAL
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {invoiceDetails &&
                              invoiceDetails?.map((item) => (
                                <tr>
                                  <td>
                                    {invoiceStatus(item.status)}
                                    <label className="boldLabel ml-2">
                                      {item?.lm_course?.course_name}{" "}
                                    </label>
                                    {item?.lm_program?.lm_assign_program && (
                                      <label className="m-auto" style={{ fontSize: 12 }}>
                                        &nbsp; By &nbsp;
                                        {
                                          item?.lm_program?.lm_assign_program[0]?.teacher_nu_users
                                            ?.user_name
                                        }
                                      </label>
                                    )}
                                  </td>
                                  {/* <td>
                                <label className="boldLabel">Jan-Feb</label>
                              </td> */}
                                  {/* <td className="text-center">
                                    <label className="text-muted" style={{ fontSize: 12 }}>
                                      None if paid by {moment(item?.due_date).format("Do MMM YY")}
                                    </label>
                                  </td> */}
                                  <td className="text-center">
                                    <label className="boldLabel">PKR {Number(item?.amount_payable).toLocaleString()}</label>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        <div className="col-md-12 singleLine"></div>
                      </div>
                      <div className="col-md-8"></div>
                      <div className="col-md-4 mt-5">
                        <div className="d-flex justify-content-between">
                          <label className="boldLabel">Sub Total : </label>
                          <label className="boldLabel">PKR {Number(totalAmount()).toLocaleString()}</label>
                        </div>
                        <div className="d-flex justify-content-between">
                          <label className="boldLabel">Tax : </label>
                          <label className="boldLabel">PKR 0</label>
                        </div>
                      </div>
                      <div className="col-md-8"></div>
                      <div className="col-md-4 singleLine mt-3"></div>
                      <div className="col-md-8"></div>
                      <div className="col-md-4">
                        <div className="d-flex justify-content-between mt-2">
                          <label className="boldLabel">Total : </label>
                          <label className="boldLabel">PKR {Number(totalAmount()).toLocaleString()}</label>
                        </div>
                      </div>
                      <div className="col-md-8"></div>
                      {/* <div className="col-md-4">
                        <button className="btn btn-success btn btn-block mt-4 font-weight-bold">
                          PAY NOW
                        </button>
                      </div> */}
                    </div>
                  </div>

                  <div className="col-md-12 p-3" style={{ background: "#E9EFF8" }}>
                    <h5 style={{ color: "#004AAD" }}>Terms & Conditions</h5>
                    <p style={{ color: "#004AAD" }}>
                      The monthly fee is non-refundable even if the student discontinues before
                      completing the month All fees should be paid before the due date to avoid late
                      fees of Rs. 750 per course
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AggregateInvoiceDesign;
